import { t } from 'i18next'
import { ReferenceItem } from "./ReferenceItem"
import { referenceKeys } from "@/data"

export function ReferenceList() {

  return(
    <section id="references">
    <div className="content-wrapper flow-content">
      <h2>{t('reference-title')}</h2>
      <div className="grid grid-column-auto grid-gap grid-gap--small">
        {referenceKeys.map((v, index) => {
          return(
            <ReferenceItem 
              key={index}
              name={t(`${v}.name`)}
              title={t(`${v}.title`)}
              email={t(`${v}.email`)}
              phone={t(`${v}.phone`)}
            />
          )
        })}
      </div>
    </div>
  </section>
  )
}